<template>
  <div>
    <h2>
      Resources
    </h2>
    <p><a href="https://www.mass.gov/doc/biomap2-summary-report/download" target="_blank">BioMap 2 Summary Report
        (2010)</a></p>
    <p><a href="http://maps.massgis.state.ma.us/dfg/biomap/pdf/town_core/Provincetown.pdf" target="_blank">BioMap 2
        &mdash; <i>Conserving the Biodiversity of Massachusetts in a Changing World</i> (Provincetown Edition 2012)</a>
    </p>
    <p><a href="http://maps.massgis.state.ma.us/dfg/biomap2.htm" target="_blank">BioMap 2
        &mdash; MassGIS Interactive Map</a></p>
  </div>
</template>

<script>

  export default {
    name: 'resources',
    components: {
    }
  }
</script>